<template>
  <div class="list">
    <div class="header">
      <div class="l">
        <div class="label">
          优惠券
        </div>
        <el-select
          v-model="searchForm.couponId"
          placeholder="请选择优惠券"
          filterable
          clearable
          @change="getList()"
        >
          <el-option
            v-for="item in couponList"
            :key="item.id"
            :label="item.couponName"
            :value="item.id"
          />
        </el-select>
      </div>
      <div class="r">
        <el-input
          v-model="searchForm.userMobilePhone"
          placeholder="请输入用户手机号"
          @keyup.enter.native="getList()"
        >
          <el-button
            slot="append"
            type="primary"
            @click="getList()"
          >
            搜索
          </el-button>
        </el-input>
        <el-button
          type="primary"
          size="middle"
          @click="create(null)"
        >
          添加用户优惠券
        </el-button>
      </div>
    </div>
    <data-table
      :data="tabelData"
      :table-column="tableColumn"
      :pagination="true"
      @changeBypagination="tableHandle"
      @buttonClick="buttonClick"
    />
    <user-coupon-dialog
      :dialog-visible.sync="couponDialogVisible"
      :item="activeCouponItem"
      @confirm="getList()"
    />
  </div>
</template>

<script>
import axClient from '@/services';
import dataTable from '@/components/common/dataTable.vue';
import { couponTypeList, sourceTypeList } from '@/config';
import userCouponDialog from '../dialog/userCouponDialog.vue';

export default {
  name: 'Order',
  components: {
    dataTable,
    userCouponDialog,
  },
  data() {
    return {
      couponList: [],
      couponDialogVisible: false,
      activeCouponItem: null,
      searchForm: {
        couponId: null,
        userMobilePhone: null,
        pageNum: 1,
        pageSize: 10,
      },
      tabelData: {},
      tableColumn: [
        {
          key: 'id',
          label: '优惠券id',
          dataType: 'text',
        },
        {
          key: 'couponName',
          label: '优惠券名称',
          dataType: 'text',
        },
        {
          key: 'couponType',
          label: '优惠券类型',
          dataType: 'function',
          render: (key) => couponTypeList.filter((item) => item.value === key),
        },
        {
          key: 'userRealName',
          label: '领用人',
          dataType: 'text',
        },
        {
          key: 'userMobilePhone',
          label: '领用人手机号',
          width: '100px',
          dataType: 'text',
        },
        {
          key: 'sourceType',
          label: '获取来源',
          dataType: 'function',
          render: (key) => sourceTypeList.filter((item) => item.value === key),
        },
        {
          key: 'discountFee',
          label: '优惠金额',
          width: 'auto',
          dataType: 'money',
        },
        {
          key: 'couponEndAt',
          label: '过期时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'usedAt',
          label: '使用时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'createAt',
          label: '创建时间',
          width: 'auto',
          dataType: 'time',
        },
        {
          key: 'control',
          label: '操作',
          width: '120px',
          dataType: 'component',
          renderProps: [
            {
              text: '删除', renderKey: null, type: 'danger', eventIndex: 0, disableKey: null,
            },
          ],
          render: () => 'buttons',
        },
      ],
    };
  },
  mounted() {
    this.getList();
    this.getCouponSelect();
  },
  methods: {
    // 获取列表
    async getList(num = 1) {
      this.searchForm.pageNum = num;
      const result = await axClient.coupon.userCouponPage(this.searchForm);
      const { pageNum, pageSize, total } = result;
      this.tabelData = {
        pageNum,
        pageSize,
        total,
        list: result.list,
      };
    },
    // table 传递过来的按钮点击
    buttonClick(type, item) {
      switch (type) {
        case 0:
          this.confirmDialog(item);
          break;
        default:
          break;
      }
    },
    // 新增优惠券
    create(item) {
      this.activeCouponItem = item;
      this.couponDialogVisible = true;
    },
    // 启用/禁用 优惠券
    confirmDialog(item) {
      this.$confirm('确定删除该用户优惠券？', '删除用户优惠券', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        showClose: false,
        type: 'error',
      }).then(async() => {
        const { id } = item;
        const data = await axClient.coupon.userCouponDelete(
          {
            id,
          },
        );
        if (data) {
          this.$message.success('删除成功');
          this.getList();
        }
      });
    },
    // table 改变 pagination 时间
    tableHandle(pageNum, pageSize) {
      this.searchForm.pageNum = pageNum;
      this.searchForm.pageSize = pageSize;
      this.getList(pageNum);
    },
    async getCouponSelect() {
      this.couponList = await axClient.coupon.couponSelect({ couponType: null });
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
